import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios, { AxiosError } from "axios";
import { useNavigate } from "react-router-dom";
import { Send } from "lucide-react";

const initialValues = {
  fullname: "",
  email: "",
  contactno: "",
  message: "",
};

const url = "https://theinnovativesolutions.onrender.com/api/contact/addmessage";

export default function ContactForm() {
  const navigate = useNavigate();

  const { values, handleBlur, touched, handleChange, handleSubmit, errors } =
    useFormik({
      initialValues: initialValues,
      validationSchema: Yup.object({
        fullname: Yup.string()
          .min(2, "Too Short")
          .max(25, "Too Long")
          .required("Please Enter Your Name"),
        email: Yup.string().email("Invalid email").required("Please Enter Your Email"),
        contactno: Yup.string().required("Please Enter Your Contact Number"),
        message: Yup.string()
          .min(2, "Too Short")
          .max(500, "Too Long")
          .required("Please Enter Your Message"),
      }),

      onSubmit: (values, action) => {
        axios
          .post(
            url,
            JSON.stringify({
              fullname: values.fullname,
              email: values.email,
              contactno: values.contactno,
              message: values.message,
            }),
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: window.sessionStorage.getItem("token"),
              },
            }
          )
          .then(function (response) {
            console.log("api response", response.data);
            if (response.status === 200 || response.status === 201) {
              alert("Message sent Successfully");
              action.resetForm();
              navigate("/");
            }
          })
          .catch(function (error) {
            if (error instanceof AxiosError && error.response?.data?.message)
              alert(error.response.data.message);
            else alert("Some error occurred");
            console.log("Error", error);
          });
      },
    });

  return (
    <form onSubmit={handleSubmit} className="row g-3">
      {/* Full Name */}
      <div className="col-12 custom-form-group">
        <label className="custom-form-label" htmlFor="fullname">Full Name *</label>
        <input
          id="fullname"
          name="fullname"
          type="text"
          placeholder="John Doe"
          className="custom-form-input"
          value={values.fullname}
          onChange={handleChange}
          onBlur={handleBlur}
          required
        />
        {errors.fullname && touched.fullname && (
          <div className="custom-form-error">{errors.fullname}</div>
        )}
      </div>

      {/* Email Address */}
      <div className="col-12 custom-form-group">
        <label className="custom-form-label" htmlFor="email">Email Address *</label>
        <input
          id="email"
          name="email"
          type="email"
          placeholder="john.doe@example.com"
          className="custom-form-input"
          value={values.email}
          onChange={handleChange}
          onBlur={handleBlur}
          required
        />
        {errors.email && touched.email && (
          <div className="custom-form-error">{errors.email}</div>
        )}
      </div>

      {/* Phone Number */}
      <div className="col-12 custom-form-group">
        <label className="custom-form-label" htmlFor="contactno">Contact No *</label>
        <input
          id="contactno"
          name="contactno"
          type="text"
          placeholder="+91 9371001138"
          className="custom-form-input"
          value={values.contactno}
          onChange={handleChange}
          onBlur={handleBlur}
          required
        />
        {errors.contactno && touched.contactno && (
          <div className="custom-form-error">{errors.contactno}</div>
        )}
      </div>

      {/* Message Textarea */}
      <div className="col-12 custom-form-group">
        <label className="custom-form-label" htmlFor="message">Message *</label>
        <textarea
          id="message"
          name="message"
          placeholder="How can we help you?"
          className="custom-form-textarea"
          value={values.message}
          onChange={handleChange}
          onBlur={handleBlur}
          required
        />
        {errors.message && touched.message && (
          <div className="custom-form-error">{errors.message}</div>
        )}
      </div>

      {/* Submit Button */}
      <div className="col-12">
        <button type="submit" className="custom-submit-pill">
          <span>Submit</span>
          <Send size={15} />
        </button>
      </div>
    </form>
  );
}
